export default "__VITE_ASSET__C8bkCryc__"